import React from 'react';
import { Grid } from '@mui/material';
import EsfirusSelect from '@components/ui/Select/EsfirusSelect';
import EsfirusTextInput from '@components/ui/Text-input/EsfirusTextInput';

const MINUTES_OPTIONS = [
  { label: "0", value: 0 },
  { label: "15", value: 15 },
  { label: "30", value: 30 },
  { label: "45", value: 45 }
]

interface TimeInputsContainerProps {
  hours: number;
  minutes: number;
  onChange: (minutesHours: { minutes: number; hours: number }) => void;
  onBlur?: (minutesHours: { minutes: number; hours: number }) => void;
  modifiedHours: boolean;
  modifiedMinutes: boolean;
  disabled: boolean;
}

const TimeInputsContainer: React.FC<TimeInputsContainerProps> = ({
  minutes,
  hours,
  onChange,
  onBlur,
  modifiedHours,
  modifiedMinutes,
  disabled
}) => {
  return (
    <>
      <Grid item xs={6} md={2}>
        <label>Horas</label>
        <EsfirusTextInput
          type="number"
          fullWidth
          value={hours}
          InputProps={{ inputProps: { min: 0 } }}
          onChange={(e: any) => onChange({ minutes, hours: Number(e.target.value) })}
          onBlur={onBlur}
          modified={modifiedHours}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={6} md={2}>
        <label>Minutos</label>
        <EsfirusSelect
          options={MINUTES_OPTIONS}
          change={(value: string) => onChange({ hours, minutes: Number(value) })}
          blur={onBlur}
          value={minutes}
          placeholder={'Minutos'}
          modified={modifiedMinutes}
          disabled={disabled}
          disableBlank
        />
      </Grid>
    </>
  );
};

export default TimeInputsContainer;
